"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDivider = exports.StyledWrapChildren = exports.StyledSmallWrapChildren = exports.StyledWrapIcons = exports.StyledWrapName = exports.Content = exports.StyledWrapModalHeader = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledWrapModalHeader = styled_components_1.default.div `
  border-bottom: 1px solid #e0e0e0;
  color: ${({ theme }) => theme.text.primary};
  font-size: 20px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
  min-height: 34px;
  height: auto;
`;
exports.Content = styled_components_1.default.div `
  border-radius: 4px;
  background-color: ${({ color, theme }) => color || theme.white};
  width: ${({ isSmall }) => (isSmall ? `433px` : `80vw`)};
  min-width: ${({ isSmall }) => (isSmall ? `433px` : `700px`)};
  height: ${({ isSmall }) => (isSmall ? `auto` : `90vh`)};
`;
exports.StyledWrapName = styled_components_1.default.span `
  margin-left: ${({ isSmallMargin }) => (isSmallMargin ? "19px" : "48px")};
  font-size: 24px;
`;
exports.StyledWrapIcons = styled_components_1.default.span `
  display: flex;
  align-items: center;
`;
exports.StyledSmallWrapChildren = styled_components_1.default.div `
  width: auto;
  height: auto;
  padding: 32px 48px 48px;
`;
exports.StyledWrapChildren = styled_components_1.default.div `
  overflow: auto;
  width: auto;
  height: auto;
  max-height: 80vh;
  padding: 32px 48px 48px;
`;
exports.StyledDivider = styled_components_1.default.div `
  height: 34px;
  border-left: 1px solid #e0e0e0;
  margin-left: 11px;
  margin-right: 11px;
`;
